document.addEventListener('DOMContentLoaded', function() {
  fetch(`https://widget.trustpilot.com/trustbox-data/56278e9abfbbba0bdcd568bc?businessUnitId=6485ae20faa76cdda508dca5&locale=${window.Shopify.locale}-${window.Shopify.country}`)
    .then(response => response.json())
    .then(response => {
      const reviewCount = response.businessUnit.numberOfReviews.total;
      const trustScore = response.businessUnit.trustScore;

      document.querySelectorAll('.trustCount').forEach(el => {
        el.innerHTML = reviewCount.toLocaleString('sv-SE');
      });

      document.querySelectorAll('.trustStar').forEach(el => {
        el.innerHTML = trustScore;
      });
    });

  function equalizeColumnHeights() {
    const gallery = document.querySelector('.product-gallery');
    const info = document.querySelector('.product-info');
    if (info && gallery) {
      gallery.style.maxHeight = `${info.scrollHeight}px`;
    }
  }

  equalizeColumnHeights();
  window.addEventListener('load', equalizeColumnHeights);
  window.addEventListener('resize', equalizeColumnHeights);
});
